import React from 'react';
import { observer } from 'mobx-react-lite';
import { ActionIcon, Badge } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';
import { useStore } from '../../state';
import { THEME_COLORS } from '../../theme/ThemeConstants';

interface CartIconButtonProps {
  color?: string;
  size?: number;
}

// Cart affordance for the site chrome (top nav + mobile header). Opens the
// global cart drawer and shows a live item-count badge. `observer` so the badge
// tracks cartStore.items.length.
export const CartIconButton: React.FC<CartIconButtonProps> = observer(({ color = '#ffffff', size = 22 }) => {
  const { applicationStore, cartStore } = useStore();
  const count = cartStore.totalQuantity;

  return (
    <ActionIcon
      variant='subtle'
      onClick={() => applicationStore.toggleCart()}
      aria-label='Open cart'
      style={{ position: 'relative', color, overflow: 'visible' }}
    >
      <IconShoppingCart size={size} color={color} />
      {count > 0 && (
        <Badge
          size='xs'
          circle
          style={{
            position: 'absolute',
            top: -4,
            right: -4,
            backgroundColor: THEME_COLORS.accent.primary,
            color: '#ffffff',
            border: 'none',
            pointerEvents: 'none'
          }}
        >
          {count}
        </Badge>
      )}
    </ActionIcon>
  );
});
